import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormFieldInstance} from '../model/FormFieldInstance';
import {FormFieldType} from '../model/FormFieldType';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {DynamicFormInnerService} from '../lib/dynamic-form-inner.service';
import {DynamicFormControl} from '../lib/DynamicFormControl';
import {FieldControl} from '../lib/FieldControl';

@Component({
  selector: 'app-dynamic-form',
  exportAs: 'appDynamicForm',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  providers: [DynamicFormInnerService],
})
export class DynamicFormComponent implements OnInit, OnDestroy {
  @Input() dynamicFormControl: DynamicFormControl;
  FormFieldType = FormFieldType;

  constructor(private readonly innerService: DynamicFormInnerService) { }

  ngOnInit(): void {
    this.innerService.dynamicFormControl = this.dynamicFormControl;
  }

  ngOnDestroy(): void {
    this.innerService.dynamicFormControl.completeValueChanged();
  }

  getId(index: number, field: FormFieldInstance) {
    return field.fieldId;
  }

  onFieldInit(field: FormFieldInstance, viewRef: AbstractDynamicFormFieldDirective) {
    // @ts-ignore
    const fieldControl = field.__fieldControl as FieldControl;
    fieldControl.viewRef = viewRef;
    // @ts-ignore
    delete field.__fieldControl;
  }
}
